export const TaskListSearchIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path
        d="M17.5,3.5a1,1,0,0,0-1-1H12.052a3.329,3.329,0,0,0-6.1,0H1.5a1,1,0,0,0-1,1v17a1,1,0,0,0,1,1h15a1,1,0,0,0,1-1Z"
        fill="#00e6ca"
      />
      <path d="M14.5,5.5H3.5v13h11Z" fill="#c4f0eb" />
      <polygon points="3.5 16.539 14.5 5.539 14.5 5.498 3.5 5.498 3.5 16.539" fill="#f8fafc" />
      <path
        d="M14.5,10V5.5H3.5v13h6"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5,9V3.5a1,1,0,0,0-1-1H12.052a3.329,3.329,0,0,0-6.1,0H1.5a1,1,0,0,0-1,1v17a1,1,0,0,0,1,1h9"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.5,8.5h5" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.5,11.5h5" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.5,14.5h3" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M17.029,21.556A4.529,4.529,0,1,0,12.5,17.027,4.529,4.529,0,0,0,17.029,21.556Z"
        fill="#00e6ca"
      />
      <path
        d="M17.029,12.5a4.527,4.527,0,0,0-3.188,7.743l6.4-6.4A4.509,4.509,0,0,0,17.029,12.5Z"
        fill="#c4f0eb"
      />
      <path
        d="M17.029,21.556A4.529,4.529,0,1,0,12.5,17.027,4.529,4.529,0,0,0,17.029,21.556Z"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5,23.5l-3.248-3.248"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
